import React from 'react';
import HeroSection from '../components/HeroSection/HeroSection';
import StatsBar from '../components/StatsBar/StatsBar';
import AboutSection from '../components/AboutSection/AboutSection';
import MachinerySection from '../components/MachinerySection/MachinerySection';
import WhyChooseUs from '../components/WhyChooseUs/WhyChooseUs';
import TestimonialsSection from '../components/TestimonialsSection/TestimonialsSection';
import FaqSection from '../components/FaqSection/FaqSection';
import PromoBanner from '../components/PromoBanner/PromoBanner';

const HomePage = () => {
  return (
    <main className="home-page">
      {/* Hero Banner Section */}
      <HeroSection />

      {/* Statistics & Metrics Section */}
      <StatsBar />

      {/* About Us Section with Scroll-Driven Video Expand Animation */}
      <AboutSection />

      {/* Our Machinery Section with Sticky Scroll Stack Animation */}
      <MachinerySection />

      {/* Why Choose DEXA Feature Section */}
      <WhyChooseUs />

      {/* Testimonials & Partner Brand Logos Section */}
      <TestimonialsSection />

      {/* FAQ Accordion Section */}
      <FaqSection />

      {/* Special Promo Machine Banner Section */}
      <PromoBanner />
    </main>
  );
};

export default HomePage;
